/*
 * Copyright (c) 2018 SGS Europe. All rights reserved.
 *
 * This program is the CONFIDENTIAL and PROPRIETARY property of SGS Europe.
 * Any unauthorised use, reproduction, or transfer of this program is strictly
 * prohibited.
 *
 * File Name:	ProgressBar.js
 *
 * Description: Contains the functions required for adding, updating and removing the progress bar.
 *
 */

var g_oProgressBar = {

    /**
     * Adds the progress bar to the page.
     * @param {string} message - The message to display.
	 * @param {bool} showPercentage - If the percentage bar should be shown.
     */
	addProgressBar: function (message, showPercentage) {

		// Show the progress bar, locking the screen.
		if ($("#divProgressBar").is(":hidden")) {
			lockScreen();
			$("#divProgressBar").show();
		}

		// Update the message.
		$("#spLoadingMessage").text(message);

		// Toggle the visibility of the percentage.
		if (showPercentage) {
			$("#divLoadingProgressBarBG").show();
		}
		else {
			$("#divLoadingProgressBarBG").hide();
		}
	},

	/**
	*  Updates the progress bar.
	*  @param {string} percentLoaded - The percentage to display.
	*  @param {string} message - The message to display.
	*/
	updateProressBar: function (percentLoaded, message) {
		// Update the message if supplied.
		if (message) {
			$("#spLoadingMessage").text(message);
		}

		// Get the current width of the progress bar.
		var currentPercent = parseFloat($("#divLoadingProgressBar").css("width")) / $("#divLoadingProgressBarBG").width() * 100;

		// Update the percentage bar only if the new percentage is greater than the current percentage.
		if (percentLoaded > currentPercent) {
			$("#divLoadingProgressBar").css("width", percentLoaded + "%");
		}
	},

	/**
	*  Removes the progress bar from the page.
	*/
	removeProgressBar: function () {

		// Unlock the screen.
		unlockScreen();

		// Reset the message and percentage.
		$("#spLoadingMessage").text("");
		$("#divLoadingProgressBar").css("width", "0%");

		// Hide the progress bar.
		$("#divProgressBar").hide();
	}
};